<template>
  <v-card class="pa-4">
    <v-card-text class="pb-0">
      <p class="pa-3 mb-0">
        Are you sure you want to delete the bookmark <span class="font-weight-bold">{{ deleteLabelBookmark }}</span>?
      </p>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn
        color="coolgray"
        text
        @click.stop="cancelDeleteBookmark"
      >
        Cancel
      </v-btn>

      <v-btn
        color="toasted"
        text
        @click.stop="deleteBookmark"
      >
        Delete it
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import BookmarkMixin from 'src/tools/store/utils/bookmarks-mixin'

export default {
  name: 'BookmarkDelete',
  mixins: [
    BookmarkMixin,
  ],
}
</script>
